export default __webpack_public_path__ + "static/media/carafem.fede4a1f.png";